module.exports = __webpack_public_path__ + "img/party.5ba82809.jpg";